/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CustomIcons from '../icons/CustomIcons';

const useStyles = makeStyles((theme) => ({
    outlineButton: {
        color: '#5567D5',
        borderRadius: '6px',
        textTransform: 'capitalize',
        borderColor: '#5567D5',
        fontSize: '11px',
    },
}));

interface OutlineButtonProps {
    buttonLabel: string,
    className?: string,
    startIcon?: JSX.Element,
    disabled?: boolean,
    testId?: string,
    onClick: ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void) | undefined
}

function OutlineButton(props: OutlineButtonProps) {
    const classes = useStyles();
    const handleOutlineButtonClick = props.onClick
    const outlineButtonlabel = props.buttonLabel;
    const { startIcon, disabled, className, testId } = props
    return (
            <Button
                variant="outlined"
                color="default"
                classes={{root: classes.outlineButton}}
                className={className}
                onClick={handleOutlineButtonClick}
                startIcon={startIcon}
                disabled={disabled}
                data-testid={testId}
            >
                &nbsp;{outlineButtonlabel}
            </Button>
    )
}

export default OutlineButton;
